import { createAction } from '@reduxjs/toolkit';

export const KEYBOARD_EVENT = createAction<KeyboardEventPayload>(
  'vtn-app-state-keyboard/KEYBOARD_EVENT'
);

export interface KeyboardEventPayload
  extends Pick<
    KeyboardEvent,
    'key' | 'altKey' | 'metaKey' | 'shiftKey' | 'ctrlKey'
  > {
  readonly type: 'keyup' | 'keydown';
}

export const actionKeyboardEvent = (payload: KeyboardEventPayload) =>
  KEYBOARD_EVENT(payload);
